import type { FaireProductEntity } from "../../entity_types/product";

export const p_7juvcyru44: FaireProductEntity = {
  token: "p_7juvcyru44",
  type: "product",
  name: "Musashi's Smoked Tomato Oil",
  brandToken: "b_wzx8v3srb4",
  brandName: "Algae Cooking Club",
  imageUrl:
    "https://cdn.faire.com/fastly/0a0455c3c8d69d2b029538ea5ef7caa7175292d5228d9d50574c2c94be5bb2e9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0aad5b116b6fba738377a6db05eeede2cff89728ec1342e9673bcdefdff4e4b7.png",
    "https://cdn.faire.com/fastly/505c841d8d5d7d4af9e6dd122c4ede5767644e3d859cb81adf711f92c0ace946.jpeg",
  ],
  priceDollars: 13,
  description:
    "🔥 The Flavor of Summer Tomatoes. Now in a Bottle. Capture peak tomato season with Musashi's Smoked Tomato Oil, a limited seasonal collaboration inspired by summer tomatoes gently charred on the grill. Developed with chef Musashi Osaki, this savory finishing oil layers rich tomato flavor with hints of basil, garlic, and smoke, all steeped low and slow in our buttery, chef-grade algae oil.\n\n💡 Why You'll Love It:\n✔ Peak Tomato Season, Bottled – Deep tomato flavor inspired by sun-ripened tomatoes fresh off the grill\n✔ Gently Smoky & Savory – Layered notes of tomato, basil, garlic, and smoke\n✔ Drizzle-Worthy – Rich enough to transform a dish, light enough to use every day\n✔ Chef-Crafted – Developed with chef Musashi Osaki, formerly of Blue Hill and Michelin-starred Restaurant Yuu\n✔ Better Oil, Better Flavor – Made with our Omega-9 rich algae oil, known for its clean, buttery taste\n\n✨ Perfect Pairings:\n🍅 Caprese salads, pan con tomate & tomato sandwiches\n🍝 Summer pasta, pizza & grilled vegetables\n🥄 Whipped ricotta, aioli & vinaigrettes\n🐟 Grilled branzino & roasted seafood\n🍸 Zero-proof martinis, savory spritzes & Bloody Marys\n🍨 Vanilla gelato & lemon sorbet\n\n👨 🍳 Chef's Note:\n\"Peak tomato season never lasts long enough. We created this oil to capture it in a bottle.\"\n— Musashi Osaki",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:25.474Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
